export default __webpack_public_path__ + "static/media/expandIcon.2f752288.svg";